/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialect_Label_Sreality_XmlInputs */

const cs_import_dialect_label_sreality_xml = /** @type {(inputs: Import_Dialect_Label_Sreality_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality XML`)
};

const en_import_dialect_label_sreality_xml = /** @type {(inputs: Import_Dialect_Label_Sreality_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality XML`)
};

/**
* | output |
* | --- |
* | "Sreality XML" |
*
* @param {Import_Dialect_Label_Sreality_XmlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect_label_sreality_xml = /** @type {((inputs?: Import_Dialect_Label_Sreality_XmlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialect_Label_Sreality_XmlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect_label_sreality_xml(inputs)
	return cs_import_dialect_label_sreality_xml(inputs)
});